import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadIndicatorService {

  public isShown = false

  constructor() { }

  show (): void {
    this.isShown = true
  }

  hide (): void {
    this.isShown = false
  }

}







